import { Facebook, Instagram, Phone, Mail, LogIn } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { bnNum } from "@/constants/site";
import { useSite } from "@/lib/site";
import { useLang } from "@/lib/lang";

export default function Footer() {
  const SITE = useSite();
  const { lang, t } = useLang();
  const navigate = useNavigate();

  return (
    <footer className="relative pt-16 pb-8 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5 flex justify-center lg:justify-start">
            <div className="rounded-3xl bg-[#FDF6EA] p-5 sm:p-7 frame-gold max-w-sm w-full" data-testid="footer-logo-panel">
              <img src="/logo.jpg" alt={SITE.nameBN} className="w-full rounded-xl" />
            </div>
          </div>

          <div className="lg:col-span-7">
            <p className="font-bengali font-extrabold text-3xl sm:text-4xl gold-text">{SITE.shortBN}</p>
            <p className="font-bengali text-lg text-[#FDF6EA]/90 mt-1">{SITE.subBN}</p>
            <p className="font-bengali text-[#D1BBA7] mt-4 max-w-xl leading-relaxed">
              {SITE.addressBN} · {t("con_landmark")} {SITE.landmark}
            </p>
            <p className="font-bengali text-[#F2B134] mt-3 text-lg">
              {lang === "en"
                ? `1943 — 2026 · ${SITE.yearsOfTradition} years of tradition · ${t("hero_theme")}`
                : `১৯৪৩ — ২০২৬ · ঐতিহ্যের ${bnNum(SITE.yearsOfTradition)} বছর · ${t("hero_theme")}`}
            </p>

            <div className="mt-6 flex flex-wrap gap-3">
              <a href={`tel:+91${SITE.phones[0]}`} className="inline-flex items-center gap-2 rounded-full border border-[#F2B134]/25 px-4 py-2 text-xs text-[#D1BBA7] hover:text-[#F2B134] transition-colors" data-testid="footer-phone-link">
                <Phone size={13} /> {SITE.phones[0]}
              </a>
              <a href={`mailto:${SITE.email}`} className="inline-flex items-center gap-2 rounded-full border border-[#F2B134]/25 px-4 py-2 text-xs text-[#D1BBA7] hover:text-[#F2B134] transition-colors" data-testid="footer-email-link">
                <Mail size={13} /> {t("con_email")}
              </a>
              <a href={SITE.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="h-9 w-9 grid place-items-center rounded-full border border-[#F2B134]/25 text-[#D1BBA7] hover:text-[#F2B134] transition-colors" data-testid="footer-facebook-link">
                <Facebook size={14} />
              </a>
              <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="h-9 w-9 grid place-items-center rounded-full border border-[#F2B134]/25 text-[#D1BBA7] hover:text-[#F2B134] transition-colors" data-testid="footer-instagram-link">
                <Instagram size={14} />
              </a>
            </div>
          </div>
        </div>

        <div className="hairline mt-12" />
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#D1BBA7]/60">
          <p className="font-bengali">© {lang === "en" ? SITE.year : bnNum(SITE.year)} {SITE.nameBN} — {t("fot_rights")}</p>
          <p className="font-bengali">{t("fot_tagline")}</p>
          <button onClick={() => navigate("/login")} data-testid="footer-login-link" className="inline-flex items-center gap-1.5 text-[#D1BBA7]/50 hover:text-[#F2B134] transition-colors">
            <LogIn size={11} /> {t("fot_login")}
          </button>
        </div>
      </div>
    </footer>
  );
}
